import { render, staticRenderFns } from "./EmailBinding.vue?vue&type=template&id=63a94f16&"
import script from "./EmailBinding.vue?vue&type=script&lang=ts&"
export * from "./EmailBinding.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports